import axios from "axios";
import { toast } from "react-toastify";
import HelperService from "./HelperService";


//Development

const BASE_URL = process.env.REACT_APP_API_URL
//const BASE_URL = "https://saferstopsapi.winayak.com/"
// const BASE_URL = "https://saferstopsapi.spxsolu.com/"



interface PropData {
  action: string;
  params?: any;
  body?: any;
  isFormData?: boolean;
  isShowError?: boolean;
  isShowSuccess?: boolean;
  id?: string;
  _file?: File;
  key?: string;
}
let isSessionExpiredHandled = false;

const handleSessionExpired = () => {
  if (isSessionExpiredHandled) return;
  console.log('handleSessionExpired')
  isSessionExpiredHandled = true;

  localStorage.removeItem("access_token");
  // toast.error("Session expired. Please login again.");
  setTimeout(() => {
    window.location.replace("/inititalScreen");
  }, 1000);
};



const WebService = {
  postAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      console.log('BASE_URL', BASE_URL, "props.action", props.action)
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      };
      axios
        .post(
          `${BASE_URL}${props.action}`,
          props.isFormData ? bodyFormData : props.body,
          {
            headers: headers,
          }
        )
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error: any) => {
          // if (error && error.response && error.response.status == 401) {
          // //  this.logout();
          // handleSessionExpired();
          // }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },
  beforeLoginAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {

      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };

      axios
        .post(`${BASE_URL}${props.action}`, props.body, { headers })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error: any) => {

          const apiError = error?.response?.data;

          if (props.isShowError) {
            toast.error(apiError?.message || "Something went wrong");
          }

          reject(apiError || error);
        });
    });
  },

  uploadAPI: function (props: PropData) {
    let formData = new FormData();
    if (props._file && props.key) {
      formData.append(props.key, props._file);
    }
    return new Promise((resolve, reject) => {
      for (let key in props.body) {
        formData.append(key, props.body[key]);
      }
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
      };
      axios
        .post(`${BASE_URL}${props.action}`, formData, {
          headers: headers,
        })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error: any) => {
          // if (error && error.response && error.response.status == 401) {
          // //  this.logout();
          // handleSessionExpired();
          // }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },
  putAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
        xapikey: localStorage.getItem("p_user_id"),
      };
      axios
        .put(`${BASE_URL}${props.action}`, props.body, {
          headers: headers,
        })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error: any) => {
          // if (error && error.response && error.response.status == 401) {
          // //  this.logout();
          // handleSessionExpired();
          // }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  getAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      };
      axios
        .get(`${BASE_URL}${props.action}`, {
          headers: headers,
          params: props.params,
        })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error: any) => {
          // if (error && error.response && error.response.status == 401) {
          //   this.logout();
          // }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  deleteAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
      };
      axios
        .delete(`${BASE_URL}${props.action}`, {
          headers: headers,
        })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error: any) => {
          // if (error && error.response && error.response.status == 401) {
          // //  this.logout();
          // handleSessionExpired();
          // }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  errorHandler: function (error: any) {
    if (error?.response) {
      error = error.response;
    }
    var errorMessage;
    if (!error || !error.status) {
      errorMessage = "Server Not Responding";
    } else if (error.status === 401) {
      return error.data?.message;

      // errorMessage = error.data?.message
      // toast.error(errorMessage);
      // setTimeout(() => {
      //   this.logout();
      // }, 1000); // 2-second delay

      // return errorMessage;
      // errorMessage = "Unauthorized";
      // this.logout();
    } else if (error.status === 500) {
      errorMessage =
        (error &&
          error.data &&
          error.data.ErrorDetails &&
          error.data.ErrorDetails.message) ||
        "An unkown exception has occur. Please Contact administrator";
    } else {
      errorMessage = error.data.message;
    }
    toast.error(errorMessage);
    return errorMessage;
  },

  addLoader(id: any) {
    if (id) {
      var button = document.getElementById(id) as HTMLButtonElement | null;
      if (button != null) {
        button.disabled = true;
        var loader = document.createElement("span");
        loader.className = "loader";
        button.prepend(loader);
      }
    }
  },

  removeLoader(id: any) {
    if (id) {
      var button = document.getElementById(id) as HTMLButtonElement | null;
      if (button != null) {
        button.disabled = false;
        button.removeChild(button.childNodes[0]);
      }
    }
  },

  logout() {
    localStorage.removeItem("access_token");
    window.location.href = "/inititalScreen";
  },
};

axios.interceptors.response.use(
  (response: any) => response,
  (error: any) => {
    // if (error?.response?.status === 401) {
    if (error?.response?.status === 401) {
      handleSessionExpired();
      // isSessionExpiredHandled = true;
      // localStorage.removeItem("access_token");
      // toast.error("Session expired. Please login again.");
      // setTimeout(() => {
      //   window.location.href = "/login";
      // }, 1000);

      // window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);


export default WebService;
